module.exports = __webpack_public_path__ + "img/stock3.62b0667f.png";